import React from 'react';
import { Text } from '@react-pdf/renderer';
import { type, colors } from '../theme';

// Section eyebrow — small uppercase label above grouped content. Default
// color is the muted gray we use in the web app's InfoLabel, so the page
// reads with a single accent (the report's teal) rather than a confetti
// of per-section colored eyebrows.
const Eyebrow = ({ children, color = colors.muted, style }) => (
  <Text style={[type.eyebrow, { color }, style]}>{children}</Text>
);

export default Eyebrow;
